var _style, _path, _defs, _path2, _path3, _path4, _path5, _defs2, _path6, _path7, _defs3, _path8, _defs4, _path9, _path0, _path1, _g, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestors(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 339.8 102.1",
    style: {
      enableBackground: "new 0 0 339.8 102.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EAECFD;}\n\t.st1{clip-path:url(#SVGID_00000155836076802812720160000015154666198050363548_);}\n\t.st2{fill:#C2C7FB;}\n\t.st3{fill:none;stroke:#1228F3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#EAECFD;stroke:#1228F3;stroke-width:2;}\n\t.st5{clip-path:url(#SVGID_00000147187729190280653870000009077302602092764546_);}\n\t.st6{clip-path:url(#SVGID_00000147186511224465711790000011926428997737090995_);}\n\t.st7{clip-path:url(#SVGID_00000062870985865752186510000006193579202555615642_);}\n\t.st8{fill:#FAFAFF;}\n\t.st9{enable-background:new    ;}\n\t.st10{fill:#1228F3;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_62320",
    transform: "translate(-587.702 -3270.714)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_88555",
    className: "st0",
    d: "M827.6,3367.4L827.6,3367.4c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.1,0.1,0.2,0.1s0.2,0.1,0.2,0.1 c0.5,0.2,1,0.4,1.5,0.6c7.3,2.1,21.6-1.5,21.6-1.5l0,0c0.8-0.1,1.6-0.3,2.4-0.4c21.2-3.9,67.5,5.3,67.5,5.3l-11.4-29l16.5-21.2 c-5.3-6.4-41.2-7.8-41.2-7.8h-4.8l0.8,8.5v18.9h0c0,1.1,0.2,2.1,0.7,3c2.1,4.4,1,7.5-0.4,9.4c-1.3,1.7-3.2,3-5.3,3.5 c-3.5,0.9-7.1,1.3-10.7,1.3c-5.1,0-10.2-0.8-15.1-2.4c-11.3-4.1-17.5-3.7-20-3.2c-0.1,0-0.2,0-0.2,0.1c-0.4,0.1-0.8,0.2-1.2,0.4v0 c-4.1,1.6-6.2,6.3-4.6,10.4C825.1,3365.2,826.2,3366.5,827.6,3367.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45102",
    transform: "translate(823.997 3313.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45101"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 63.9,
    height: 50.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056386418564199341070000014511257609199098539_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45100",
    style: {
      clipPath: "url(#SVGID_00000056386418564199341070000014511257609199098539_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88547",
    className: "st2",
    d: "M63.9,35.8V0.1C62.3,0,61.4,0,61.4,0h-4.8l0.8,8.5v18.9h0c0,1.1,0.2,2.1,0.7,3 c2.1,4.4,1,7.5-0.4,9.4c-1.3,1.7-3.2,3-5.3,3.5c-3.5,0.9-7.1,1.3-10.7,1.3c-5.1,0-10.2-0.8-15.1-2.4c-11.3-4.1-17.5-3.7-20-3.2 c-0.1,0-0.2,0-0.2,0.1c-0.4,0.1-0.8,0.2-1.2,0.4v0C1,41-1.1,45.7,0.5,49.8c0.1,0.3,0.3,0.7,0.5,1c0,0-1-10,11.2-7.1 c8.2,1.9,26.6,7,41.8,4C59.8,46.6,63.9,41.6,63.9,35.8"
  })))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88554",
    className: "st0",
    d: "M687.6,3276.1L687.6,3276.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1 s-0.2-0.1-0.2-0.1c-0.5-0.2-1-0.4-1.5-0.6c-7.3-2.1-21.6,1.5-21.6,1.5l0,0c-0.8,0.1-1.6,0.3-2.4,0.4c-21.2,3.9-67.5-5.3-67.5-5.3 l11.4,29l-16.5,21.2c5.3,6.4,41.2,7.8,41.2,7.8h4.8l-0.8-8.5v-18.9h0c0-1.1-0.2-2.1-0.7-3c-2.1-4.4-1-7.5,0.4-9.4 c1.3-1.7,3.2-3,5.3-3.5c3.5-0.9,7.1-1.3,10.7-1.3c5.1,0,10.2,0.8,15.1,2.4c11.3,4.1,17.5,3.7,20,3.2c0.1,0,0.2,0,0.2-0.1 c0.4-0.1,0.8-0.2,1.2-0.4v0c4.1-1.6,6.2-6.3,4.6-10.4C690.1,3278.4,689,3277,687.6,3276.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88546",
    className: "st3",
    d: "M827.6,3367.4L827.6,3367.4c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.1,0.1,0.2,0.1s0.2,0.1,0.2,0.1 c0.5,0.2,1,0.4,1.5,0.6c7.3,2.1,21.6-1.5,21.6-1.5l0,0c0.8-0.1,1.6-0.3,2.4-0.4c21.2-3.9,67.5,5.3,67.5,5.3l-11.4-29l16.5-21.2 c-5.3-6.4-41.2-7.8-41.2-7.8h-4.8l0.8,8.5v18.9h0c0,1.1,0.2,2.1,0.7,3c2.1,4.4,1,7.5-0.4,9.4c-1.3,1.7-3.2,3-5.3,3.5 c-3.5,0.9-7.1,1.3-10.7,1.3c-5.1,0-10.2-0.8-15.1-2.4c-11.3-4.1-17.5-3.7-20-3.2c-0.1,0-0.2,0-0.2,0.1c-0.4,0.1-0.8,0.2-1.2,0.4v0 c-4.1,1.6-6.2,6.3-4.6,10.4C825.1,3365.2,826.2,3366.5,827.6,3367.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88544",
    className: "st4",
    d: "M848.2,3335.4c-7.5-0.3-15-0.1-22.4,0.6l-1.7,23.6c0.4-2.9,2.3-5.3,5.1-6.4v0 c0.4-0.2,0.8-0.3,1.2-0.4c0.1,0,0.2,0,0.2-0.1c2.5-0.5,8.7-0.8,20,3.2c4.9,1.6,10,2.4,15.1,2.4c3.6,0,7.2-0.4,10.7-1.3 c2.1-0.6,4-1.8,5.3-3.5c1.2-1.6,1.8-3.5,1.6-5.5C882.6,3344.4,877.4,3336.9,848.2,3335.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45108",
    transform: "translate(627.314 3278.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45107"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000169528075536322201340000002659301397497180335_",
    x: 0,
    y: 0,
    width: 63.4,
    height: 50.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128470231777539091980000010238639733871659177_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169528075536322201340000002659301397497180335_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45106",
    style: {
      clipPath: "url(#SVGID_00000128470231777539091980000010238639733871659177_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88551",
    className: "st2",
    d: "M0,14.9v35.3c1.6,0.1,2.5,0.1,2.5,0.1h4.7L6.4,42V23.3h0c0-1-0.2-2.1-0.7-3 c-2.1-4.3-1-7.4,0.4-9.4c1.3-1.7,3.2-2.9,5.3-3.5c3.5-0.9,7.1-1.3,10.7-1.3c5.1,0,10.2,0.8,15,2.4c11.2,4,17.3,3.7,19.9,3.2 c0.1,0,0.2,0,0.2-0.1c0.4-0.1,0.8-0.2,1.2-0.3v0c4.1-1.6,6.1-6.2,4.5-10.3c-0.1-0.3-0.3-0.7-0.5-1c0,0,1,9.9-11.1,7.1 c-8.1-1.9-26.4-7-41.5-4C4.1,4.2,0,9.1,0,14.9"
  })))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88548",
    className: "st4",
    d: "M667.1,3308.1c7.5,0.3,15,0.1,22.4-0.6l1.7-23.6c-0.4,2.9-2.3,5.3-5.1,6.4v0 c-0.4,0.2-0.8,0.3-1.2,0.4c-0.1,0-0.2,0-0.2,0.1c-2.5,0.5-8.7,0.8-20-3.2c-4.9-1.6-10-2.4-15.1-2.4c-3.6,0-7.2,0.4-10.7,1.3 c-2.1,0.6-4,1.8-5.3,3.5c-1.2,1.6-1.8,3.5-1.6,5.5C632.7,3299.1,637.9,3306.7,667.1,3308.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45099",
    transform: "translate(826.287 3335.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45098",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163762396108781171190000009930210175032685999_",
    x: 0,
    y: 0,
    width: 56.7,
    height: 14.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151540250175094360310000009489964121453875354_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163762396108781171190000009930210175032685999_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45097",
    style: {
      clipPath: "url(#SVGID_00000151540250175094360310000009489964121453875354_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88545",
    className: "st2",
    d: "M56.6,14.2c0-0.4,0-0.9,0-1.3C55.9,9.1,50.8,1.6,22.3,0.2C15-0.2,7.7,0,0.4,0.8L0,6.9 C10.7,4.8,43.3-0.1,56.6,14.2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45105",
    transform: "translate(631.866 3294.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45104"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000076587812376874598070000008914550963695458215_",
    x: 0,
    y: 0,
    width: 57.1,
    height: 14.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070085166625234093010000002417578007949420685_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076587812376874598070000008914550963695458215_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45103",
    style: {
      clipPath: "url(#SVGID_00000070085166625234093010000002417578007949420685_)"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88549",
    className: "st2",
    d: "M0,0c0,0.4,0,0.9,0,1.3C0.8,5,5.9,12.5,34.6,13.9c7.3,0.3,14.7,0.1,22-0.6l0.4-6 C46.3,9.3,13.4,14.1,0,0"
  })))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88550",
    className: "st3",
    d: "M687.6,3276.1L687.6,3276.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1 s-0.2-0.1-0.2-0.1c-0.5-0.2-1-0.4-1.5-0.6c-7.3-2.1-21.6,1.5-21.6,1.5l0,0c-0.8,0.1-1.6,0.3-2.4,0.4c-21.2,3.9-67.5-5.3-67.5-5.3 l11.4,29l-16.5,21.2c5.3,6.4,41.2,7.8,41.2,7.8h4.8l-0.8-8.5v-18.9h0c0-1.1-0.2-2.1-0.7-3c-2.1-4.4-1-7.5,0.4-9.4 c1.3-1.7,3.2-3,5.3-3.5c3.5-0.9,7.1-1.3,10.7-1.3c5.1,0,10.2,0.8,15.1,2.4c11.3,4.1,17.5,3.7,20,3.2c0.1,0,0.2,0,0.2-0.1 c0.4-0.1,0.8-0.2,1.2-0.4v0c4.1-1.6,6.2-6.3,4.6-10.4C690.1,3278.4,689,3277,687.6,3276.1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88553",
    className: "st8",
    d: "M880.9,3299.8c-1.1-0.9-2.3-1.7-3.3-2.4c-2.2-1.6-4.6-3-7.2-4.1l0,0c-5.7-2.5-14-4.6-26-5.7 c-10.3-0.6-36.7,1.4-36.7,1.4c-1,0.1-2,0.2-2.9,0.3c-9.4,1-29.2,4.3-47.2,7.3c-34.7,5.7-76.4,12.2-90.5,11.5 c-29.3-1.5-34.5-9-35.2-12.7v43.4c0,1.9,0.9,3.8,2.4,5c1.1,0.9,2.3,1.7,3.3,2.4c2.2,1.6,4.6,3,7.2,4.1l0,0c5.7,2.5,14,4.6,26,5.7 c10.3,0.6,36.7-1.4,36.7-1.4c1-0.1,2-0.2,2.9-0.3c9.4-1,29.2-4.3,47.2-7.3c34.7-5.7,76.4-12.2,90.5-11.5c29.3,1.5,34.5,9,35.2,12.7 v-43.4C883.4,3302.8,882.5,3301,880.9,3299.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M721.7,3317.4c0.2,0.8,1.8,11.9,1.8,13.1c-0.1,0.4-3.3,0.7-3.3,0.5c-0.3-1.3-1.7-11.3-1.8-13.1 C719,3317.6,721.6,3317.3,721.7,3317.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M727.5,3320.6c0,0.4,0.1,1,0.1,1.1c0.3-0.7,1.2-1.5,2.7-1.7c2-0.3,3.6,1.2,3.9,3.6c0.2,1.3,0.5,4.5,0.6,5.4 c0,0.2-2.8,0.5-2.9,0.5c-0.1,0-0.6-4.5-0.7-5.2c-0.1-1-0.7-1.7-1.7-1.5c-1,0.1-1.5,1-1.4,1.8c0.1,0.6,0.7,5.2,0.7,5.2 c0,0.1-2.8,0.4-2.9,0.3c0-0.1-0.8-5-1.3-9C724.7,3320.9,727.3,3320.4,727.5,3320.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M737.2,3318.9c0.2,0,2.7,5.5,2.9,5.8c0.1-0.3,1.4-6.4,1.5-6.5c0.1,0,2.9,0.2,2.9,0.3 c-0.1,1.2-2.5,9.4-2.6,9.5c-0.2,0.2-3,0.4-3,0.3c0,0-4.3-8-4.3-8.5C734.6,3319.7,737,3319,737.2,3318.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M750.6,3324.5c1-0.1,1.7-0.6,2.1-1c0.2,0.2,1.2,1.6,1.3,1.9c-0.4,0.5-1.7,1.3-3.2,1.5 c-3.4,0.5-5.1-1.6-5.4-4c-0.4-2.5,0.9-5.1,3.8-5.5c2.5-0.4,4.3,1.3,4.6,3.4c0.1,0.6,0.1,1.1,0,1.5c-0.9,0.3-4.3,0.7-5.5,0.9 C748.5,3324.1,749.3,3324.6,750.6,3324.5z M751.1,3320.9c-0.1-0.9-0.7-1.6-1.6-1.4c-1,0.1-1.5,1-1.4,1.9L751.1,3320.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M755.4,3325.3c-0.2-0.2,0.4-2.3,0.6-2.3c0.3,0.1,1.6,0.8,2.8,0.6c0.8-0.1,1.1-0.4,1-0.8 c-0.1-0.4-0.4-0.6-1.6-0.7c-2.2-0.1-3.3-0.8-3.5-2.4c-0.3-2,0.9-3.4,3.2-3.7c1.7-0.2,3.3,0.1,3.6,0.3c0.2,0.1-0.4,2.2-0.5,2.3 c-0.1,0-1.4-0.6-2.5-0.4c-0.7,0.1-1,0.5-1,0.9c0.1,0.4,0.4,0.6,1.5,0.6c2.3,0,3.4,0.6,3.6,2.4c0.2,1.7-0.7,3.3-3.3,3.7 C757.5,3326.1,755.7,3325.6,755.4,3325.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M767.7,3320.8c0.1,0.6,0.5,1,1.1,0.9c0.7-0.1,1.1-0.6,1.3-0.6c0.2,0,0.9,1.7,1,2.1c0,0-0.7,1-2.6,1.3 c-2.2,0.3-3.4-0.7-3.6-2.6c-0.1-0.9-0.4-4.1-0.5-4.2c0,0-1.2,0.2-1.3,0.1c-0.1-0.1-0.4-2.3-0.3-2.3c0.1,0,1.3-0.1,1.4-0.2 c0-0.1-0.3-2-0.2-2.2c0.1-0.2,2.7-0.7,2.8-0.6c0.1,0.1,0.3,2.5,0.3,2.5c0,0,2.1-0.4,2.3-0.2c0.2,0.2,0.3,2.2,0.3,2.2 c-0.1,0.2-2.4,0.4-2.4,0.5C767.3,3317.6,767.5,3319.7,767.7,3320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M780.6,3318c0.3,2.4-1.1,4.9-4.1,5.3c-2.7,0.4-5-1.2-5.5-4.2c-0.3-2.4,1.2-4.9,4.1-5.3 C777.8,3313.4,780.2,3314.9,780.6,3318z M775.7,3316.6c-1.3,0.1-1.9,1.1-1.7,2.3c0.2,1.3,1.1,1.9,2,1.8c1.3-0.1,1.9-1,1.7-2.4 C777.5,3316.9,776.6,3316.5,775.7,3316.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M787.7,3315.3c-0.3,0-1-0.1-1.3,0c-0.9,0.1-1.2,0.8-1.2,1.6c0,0.4,0.8,4.8,0.7,4.8c0,0.1-3.1,0.5-3.1,0.4 c-0.1-0.1-1.3-8.7-1.3-9.1c0.1-0.3,2.7-0.8,2.9-0.6c0.1,0.4,0.2,1.2,0.2,1.3c0.5-1.3,1.8-1.8,3.1-1.7 C788,3312.2,788,3314.9,787.7,3315.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M789.7,3320.5c-0.2-0.2,0.4-2.3,0.6-2.3c0.3,0.1,1.6,0.8,2.8,0.6c0.8-0.1,1.1-0.4,1-0.8 c-0.1-0.4-0.4-0.6-1.6-0.6c-2.2-0.1-3.3-0.8-3.5-2.4c-0.3-2,0.9-3.4,3.2-3.7c1.7-0.2,3.3,0.1,3.6,0.3c0.2,0.1-0.4,2.2-0.5,2.3 c-0.1,0-1.4-0.6-2.5-0.4c-0.7,0.1-1,0.5-1,0.9c0.1,0.4,0.4,0.6,1.5,0.6c2.3,0,3.4,0.6,3.6,2.4c0.2,1.7-0.7,3.3-3.3,3.7 C791.8,3321.3,790,3320.8,789.7,3320.5z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88552",
    className: "st3",
    d: "M880.9,3299.8c-1.1-0.9-2.3-1.7-3.3-2.4c-2.2-1.6-4.6-3-7.2-4.1l0,0c-5.7-2.5-14-4.6-26-5.7 c-10.3-0.6-36.7,1.4-36.7,1.4c-1,0.1-2,0.2-2.9,0.3c-9.4,1-29.2,4.3-47.2,7.3c-34.7,5.7-76.4,12.2-90.5,11.5 c-29.3-1.5-34.5-9-35.2-12.7v43.4c0,1.9,0.9,3.8,2.4,5c1.1,0.9,2.3,1.7,3.3,2.4c2.2,1.6,4.6,3,7.2,4.1l0,0c5.7,2.5,14,4.6,26,5.7 c10.3,0.6,36.7-1.4,36.7-1.4c1-0.1,2-0.2,2.9-0.3c9.4-1,29.2-4.3,47.2-7.3c34.7-5.7,76.4-12.2,90.5-11.5c29.3,1.5,34.5,9,35.2,12.7 v-43.4C883.4,3302.8,882.5,3301,880.9,3299.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestors);
export default __webpack_public_path__ + "static/media/investors.03691367e887934ff44e6a57898f2a70.svg";
export { ForwardRef as ReactComponent };